import { api } from "./client";

export type EmailSendRequest = {
  template_name: string;
  creator_ids: string[];
};

export type EmailSendResponse = {
  queued: number;
  template_name: string;
};

export const EmailsApi = {
  send(body: EmailSendRequest) {
    return api.post<EmailSendResponse>("/emails/send", body).then((r) => r.data);
  },
};
